export default "__VITE_ASSET__DAdMFjKb__"